import t from"./createElements.js";const e=(e=[],s,o,n)=>e.length?t(e,s,{...o,isInstantPayment:!0,showPayButton:!0},n):Promise.resolve([]);export{e as default};
